<template>
    <div class="user">
        <el-tabs v-model="activeName" type="border-card" class="content">
            <el-tab-pane label="总公司角色管理" name="first" v-if="this.type === 1">
                <el-tabs type="card" v-model="activeName1">
                    <!-- <el-tab-pane
                        v-for="(item,index) in options"
                        :key="index"
                        :label="item.departmentName"
                        :name="item.departmentName"
                    >
                        <childAdministrator v-if="item.departmentName == '子管理员'"></childAdministrator>
                        <Tibet1 v-else-if="item.departmentName == '客服部'"></Tibet1>
                        <ConventionalTibet v-else-if="item.departmentName == '常规客服部'"></ConventionalTibet>
                        <Finance1 v-else-if="item.departmentName == '财务部'"></Finance1>
                        <MallDepartment v-else-if="item.departmentName == '商城部'"></MallDepartment>
                        <department1 v-else-if="item.departmentName == '总公司采购部'"></department1>
                        <MallCustomerService v-else-if="item.departmentName == '商城客服部'"></MallCustomerService>
                        <Warehousekeeper v-else-if="item.departmentName == '仓库管理员'"></Warehousekeeper>
                        <warehouseService v-else-if="item.departmentName == '仓库客服部'"></warehouseService>
                        <Ministry v-else-if="item.departmentName == '信息部'"></Ministry>
                        <service v-else-if="item.departmentName == '服务部'"></service>
                        <channel v-else-if="item.departmentName == '渠道部'"></channel>
                        <operation v-else-if="item.departmentName == '操作部'"></operation>
                        <warehousing v-else-if="item.departmentName == '仓储部'"></warehousing>
                        <WarehouseFinancial v-else-if="item.departmentName == '仓库财务部'"></WarehouseFinancial>
                    </el-tab-pane> -->
                    <el-tab-pane label="子管理员" name="1">
                        <childAdministrator></childAdministrator>
                    </el-tab-pane>
                    <el-tab-pane label="客服部" name="2">
                        <Tibet1></Tibet1>
                    </el-tab-pane>
                    <el-tab-pane label="常规客服部" name="3">
                        <ConventionalTibet></ConventionalTibet>
                    </el-tab-pane>
                    <el-tab-pane label="财务部" name="4">
                        <Finance1></Finance1>
                    </el-tab-pane>
                    <el-tab-pane label="商城部" name="5">
                        <MallDepartment></MallDepartment>
                    </el-tab-pane>
                    <el-tab-pane label="总公司采购部" name="6">
                        <department1></department1>
                    </el-tab-pane>
                    <el-tab-pane label="商城客服部" name="7">
                        <MallCustomerService></MallCustomerService>
                    </el-tab-pane>
                    <el-tab-pane label="仓库管理员" name="8">
                        <Warehousekeeper></Warehousekeeper>
                    </el-tab-pane>
                    <el-tab-pane label="仓库客服部" name="9">
                        <warehouseService></warehouseService>
                    </el-tab-pane>
                    <el-tab-pane label="信息部" name="10">
                        <Ministry></Ministry>
                    </el-tab-pane>
                    <el-tab-pane label="服务部" name="11">
                        <service></service>
                    </el-tab-pane>
                    <el-tab-pane label="渠道部" name="12">
                        <channel></channel>
                    </el-tab-pane>
                    <el-tab-pane label="操作部" name="13">
                        <operation></operation>
                    </el-tab-pane>
                    <el-tab-pane label="仓储部" name="14">
                        <warehousing></warehousing>
                    </el-tab-pane>
                    <el-tab-pane label="仓库财务部" name="15">
                        <WarehouseFinancial></WarehouseFinancial>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>

            <el-tab-pane label="分公司角色管理" name="second" v-if="this.type === 2">
                <el-tabs type="card" v-model="activeName2">
                    <el-tab-pane label="财务部" name="1" v-if="this.str.system !== 4">
                        <Financedept></Financedept>
                    </el-tab-pane>
                    <el-tab-pane label="客服部" name="2" v-if="this.str.system !== 4">
                        <Tibet></Tibet>
                    </el-tab-pane>
                    <el-tab-pane label="商务部" name="3" v-if="this.str.system !== 4">
                        <Business></Business>
                    </el-tab-pane>
                    <el-tab-pane label="商务组" name="1" v-if="this.str.system == 4&&this.str.superDepartmentName == '商务部'">
                        <Businessgroup></Businessgroup>
                    </el-tab-pane>
                </el-tabs>
            </el-tab-pane>

            <el-tab-pane label="子公司角色管理" name="third" v-if="this.type === 3">
                <el-tabs type="card" v-model="activeName3">
                    <el-tab-pane
                        v-for="(item,index) in options"
                        :key="index"
                        :label="item.departmentName"
                        :name="item.departmentName"
                    >
                        <Finance v-if="item.departmentName == '财务部'"></Finance>
                        <department v-else-if="item.departmentName == '采购部'"></department>
                        <personnel v-else-if="item.departmentName == '人事部'"></personnel>
                        <operations v-else-if="item.departmentName == '运营部'"></operations>
                        <operations2 v-else-if="item.departmentName == '独立站运营部'"></operations2>
                        <operations3 v-else-if="item.departmentName == '独立站账户部'"></operations3>
                        <shopee-operation v-else-if="item.departmentName == 'Shopee运营部'"></shopee-operation>
                        <coupang-operation v-else-if="item.departmentName == 'Coupang运营部'"></coupang-operation>
                        <ozon-operation-child v-else-if="item.departmentName == 'Ozon运营部'"></ozon-operation-child>
                        <allegro-operations v-else-if="item.departmentName == 'Allegro运营部'"></allegro-operations>
                        <wish-operations v-else-if="item.departmentName == 'Wish运营部'"></wish-operations>
                        <tiktok-operations v-else-if="item.departmentName == 'TikTok运营部'"></tiktok-operations>
                        <aliexpress-operations v-else-if="item.departmentName == 'Aliexpress运营部'"></aliexpress-operations>
                        <walmart-operations v-else-if="item.departmentName == 'Walmart运营部'"></walmart-operations>
                        <mercadolibre-operations v-else-if="item.departmentName == 'Mercadolibre运营部'"></mercadolibre-operations>
                      <guanggaoyunying v-else-if="item.departmentName == '广告运营部'"></guanggaoyunying>
                      <guanggaozhanghu v-else-if="item.departmentName == '广告账户部'"></guanggaozhanghu>
                    </el-tab-pane>
                    <!-- <el-tab-pane label="Amazon运营部" name="1">
                        <operations></operations>
                    </el-tab-pane> -->
                    <!-- <el-tab-pane label="独立站运营部" name="5">
                        <operations2></operations2>
                    </el-tab-pane>

                    <el-tab-pane label="独立站账户部" name="6">
                        <operations3></operations3>
                    </el-tab-pane>

                    <el-tab-pane label="采购部" name="2">
                        <department></department>
                    </el-tab-pane>

                    <el-tab-pane label="财务部" name="3">
                        <Finance></Finance>
                    </el-tab-pane>

                    <el-tab-pane label="人事部" name="4">
                        <personnel></personnel>
                    </el-tab-pane> -->
                </el-tabs>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
import ShopeeAuthorize from "@/views/AccreditTest/ShopeeAuthorize";
let id = 1000;
import { ajaxPost, Baseurl } from "../../../api/api/api";
//子公司角色管理
import department from "./Subsidiary/department";
import Finance from "./Subsidiary/Finance";
import operations from "./Subsidiary/operations";
import operations2 from "./Subsidiary/operations2";
import operations3 from "./Subsidiary/operations3";
import personnel from "./Subsidiary/personnel";
import guanggaoyunying from "./Subsidiary/guanggaoyunying";
import guanggaozhanghu from "./Subsidiary/guanggaozhanghu";
import shopeeOperation from './Subsidiary/shopee-operation'
import coupangOperation from './Subsidiary/coupang-operation'
import ozonOperationChild from './Subsidiary/ozon-operation-child'
//分公司角色管理
import Financedept from "./Branch/Financedept";
import Tibet from "./Branch/Tibet";
import Business from "./Branch/business";
import Businessgroup from "./Branch/Businessgroup";
//总公司角色管理
import childAdministrator from "./TheHeadOffice/childAdministrator";
import Tibet1 from "./TheHeadOffice/Tibet";
import ConventionalTibet from "./TheHeadOffice/ConventionalTibet";
import Finance1 from "./TheHeadOffice/Finance";
import department1 from "./TheHeadOffice/department";
import MallDepartment from "./TheHeadOffice/MallDepartment";
import MallCustomerService from "./TheHeadOffice/MallCustomerService";
import Warehousekeeper from "./TheHeadOffice/Warehousekeeper";
import warehouseService from "./TheHeadOffice/warehouseService";
import Ministry from "./TheHeadOffice/Ministry";
import service from "./TheHeadOffice/service";
import channel from "./TheHeadOffice/channel";
import operation from "./TheHeadOffice/operation";
import warehousing from "./TheHeadOffice/warehousing";
import WarehouseFinancial from "./TheHeadOffice/WarehouseFinancial";
import ShopeeOperatiom from "@/views/jurisdiction/user/Subsidiary/shopee-operation";
import CoupangOperation from "@/views/jurisdiction/user/Subsidiary/coupang-operation";
import ozonOperation from "@/views/jurisdiction/user/Subsidiary/ozon-operation-child";
import allegroOperations from "@/views/jurisdiction/user/Subsidiary/allegro-operations";
import wishOperations from "@/views/jurisdiction/user/Subsidiary/wish-operations";
import tiktokOperations from "@/views/jurisdiction/user/Subsidiary/tiktok-operations";
import aliexpressOperations from "@/views/jurisdiction/user/Subsidiary/aliexpress-operations";
import walmartOperations from "@/views/jurisdiction/user/Subsidiary/walmart-operations";
import mercadolibreOperations from "@/views/jurisdiction/user/Subsidiary/mercadolibre-operations";
export default {
    name: "user",
    components: {
      CoupangOperation,
      ShopeeOperatiom,
      ShopeeAuthorize,
        //子公司角色管理
        department,
        Finance,
        operations,
        operations2,
        operations3,
        personnel,
        guanggaoyunying,
        guanggaozhanghu,
        shopeeOperation,
        coupangOperation,
        ozonOperationChild,
        //分公司角色管理
        Financedept,
        Tibet,
        Business,
        Businessgroup,
        //总公司角色管理
        childAdministrator,
        Tibet1,
        ConventionalTibet,
        Finance1,
        department1,
        MallDepartment,
        MallCustomerService,
        Warehousekeeper,
        warehouseService,
        Ministry,
        service,
        channel,
        operation,
        warehousing,
        WarehouseFinancial,
        allegroOperations,
        wishOperations,
        tiktokOperations,
        aliexpressOperations,
        walmartOperations,
        mercadolibreOperations,
    },
    data() {
        return {
            str:"",
            type: "",
            activeName: "",
            activeName1: "1",
            activeName2: "1",
            activeName3: "运营部",
            companyId: '',
            options: []
        };
    },
    created() {
        this.str = JSON.parse(localStorage.getItem("role"));
        this.companyId = this.str.company_id
        this.type = this.str.type;
      console.log(this.type);
      if (this.type == 1) {
            this.activeName = "first";
        } else if (this.type == 2) {
            this.activeName = "second";
        } else if (this.type == 3) {
            this.activeName = "third";
        }
        this.getDepartment()
    },
    methods: {
        getDepartment() {
            const API = Baseurl + 'departmentController/selectDepartment'
            const paramsData = {
                company_id: this.companyId
            }
            ajaxPost(API,paramsData)
                .then((res) => {
                    if(res.data.code === 200) {
                        this.options = res.data.data
                      console.log(this.options.departmentName);
                        this.options.map((i) => {
                          console.log(i.departmentName);
                        })
                    }else{
                        this.$message.error(res.data.message)
                    }
                })
        }
    },
};
</script>

<style lang="scss" scoped>
.content{
    min-height: 800px;
}
</style>
